'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdRemoveRedEye = function MdRemoveRedEye(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 15q2 0 3.5 1.5t1.5 3.5-1.5 3.5-3.5 1.5-3.5-1.5-1.5-3.5 1.5-3.5 3.5-1.5z m0 13.4q3.4 0 5.9-2.5t2.5-5.9-2.5-5.9-5.9-2.5-5.9 2.5-2.5 5.9 2.5 5.9 5.9 2.5z m0-20.9q6.2 0 11.2 3.4t7.2 9.1q-2.2 5.6-7.2 9.1t-11.2 3.4-11.2-3.4-7.2-9.1q2.2-5.6 7.2-9.1t11.2-3.4z' })
        )
    );
};

exports.default = MdRemoveRedEye;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/remove-red-eye.js
// module id = 1837
// module chunks = 168707334958949